import { FC } from 'react';
import { useSkillIcon } from '../../../../../custom-hooks/useSkillIcon';

const CORNER_POSITIONS = [
  'tw-left-[-1px] tw-top-[-3px]',
  'tw-right-[-1px] tw-top-[-3px]',
  'tw-bottom-[-5px] tw-left-[-2px]',
  'tw-bottom-[-5px] tw-right-[-2px]',
];

const SecondPageUI: FC = () => {
  const { IconComponent: SupportingIcon } = useSkillIcon({ targetSkillType: null });
  const { IconComponent: TargetIcon } = useSkillIcon({ targetSkillType: 'Target' });

  return (
    <div className="tw-flex tw-flex-col tw-gap-y-6">
      <div className="tw-flex tw-flex-col ">
        <h1 className="tw-text-xl tw-font-sora tw-font-bold tw-text-neutral-950">Every path is made of skills</h1>
        <p className="tw-text-base tw-font-atkinson tw-m-0 tw-text-neutral-700">
          A skill is a single math competency — something you could teach in one class period and check with a short
          5-10 minute quiz (in Roadmaps, this is the Skill Challenge).
          <br></br>
          <br></br>
          The{' '}
          <span className="tw-font-bold">
            skills on a path are both grade-level concepts and the supporting concepts
          </span>{' '}
          that lead up to them. Each skill builds on the last, preparing students for what comes next.
        </p>
      </div>

      <div className="tw-flex tw-flex-row tw-justify-center tw-gap-x-8 tw-py-4">
        {/* Supporting skill */}
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-3">
          <div className="tw-flex tw-h-44 tw-w-72 tw-flex-col tw-items-center tw-justify-center tw-gap-y-3 tw-rounded-2xl tw-border-3 tw-border-b-[7px] tw-border-solid tw-border-neutral-200 tw-bg-neutral-50 tw-px-6">
            <SupportingIcon />
            <p className="tw-m-0 tw-text-center tw-text-base tw-font-bold tw-font-sora tw-text-black">
              Addition &amp; Subtraction Equations
            </p>
          </div>
          <p className="tw-m-0 tw-text-sm tw-font-bold tw-font-atkinson tw-text-neutral-950">Supporting skills</p>
        </div>

        {/* Target, grade-level skill */}
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-3">
          <div className="tw-relative tw-flex tw-h-44 tw-w-72 tw-flex-col tw-items-center tw-justify-center tw-gap-y-3 tw-rounded-2xl tw-border-[9px] tw-border-b-[13.65px] tw-border-solid tw-border-amber-200 tw-bg-neutral-50 tw-px-6">
            {CORNER_POSITIONS.map(position => (
              <span
                key={position}
                className={`tw-absolute ${position} -tw-m-1 tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-amber-500`}
              />
            ))}
            <TargetIcon />
            <p className="tw-m-0 tw-text-center tw-text-base tw-font-bold tw-font-sora tw-text-black">
              Solve 2-Step Equations
            </p>
          </div>
          <p className="tw-m-0 tw-text-sm tw-font-bold tw-font-atkinson tw-text-neutral-950">
            Targets, grade-level skills
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecondPageUI;
